import { NgModule } from "@angular/core";
import { ActivityTypesLegendComponent } from "./activity-types-legend.component";
import { CommonModule } from "@angular/common";
import { AllMaterialModule } from "../../all-material.components";
import { DatepickerYearMonthComponent } from "./datepicker-year-month.component";
import { FlexLayoutModule } from "@angular/flex-layout";

@NgModule({
    imports: [
        CommonModule,
        AllMaterialModule,
        FlexLayoutModule
    ],
    declarations: [
        ActivityTypesLegendComponent,
        DatepickerYearMonthComponent
    ],
    exports: [
        ActivityTypesLegendComponent,
        DatepickerYearMonthComponent
    ]
})
export class ActivitiesSharedModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/shared/activities-shared.module.ts